import React from 'react';
import { shape, string } from 'prop-types';
import {
  Collapsible,
  HtmlParser,
  Button,
} from 'components/common';
import classNames from 'classnames';
import { Typography } from '@hyphengroup/cag-components';
import './BriefDescription.scss';

export const staticTextKeys = [
  'PROVIDER_PRODUCT_PAGE_BRIEF_DESCRIPTION_SHOW_MORE',
  'PROVIDER_PRODUCT_PAGE_BRIEF_DESCRIPTION_SHOW_LESS',
];

class BriefDescription extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      moreContent: false,
      isShowCollapsible: false,
    };

    this.descriptionRef = React.createRef();
    this.updateIsShowCollapsible = this.updateIsShowCollapsible.bind(this);
    this.handleDescriptionToggle = this.handleDescriptionToggle.bind(this);
  }

  componentDidMount() {
    this.updateIsShowCollapsible();
  }

  componentDidUpdate() {
    this.updateIsShowCollapsible();
  }

  updateIsShowCollapsible() {
    const { current: descriptionEl } = this.descriptionRef;
    if (!descriptionEl) return;
    const descriptionHeight = descriptionEl.clientHeight;
    const descriptionStyles = window.getComputedStyle(descriptionEl);
    const lineHeight = parseFloat(descriptionStyles.lineHeight, 10);
    const { isShowCollapsible: prevIsShowCollapsible } = this.state;
    const isShowCollapsible = descriptionHeight >= lineHeight * 4;
    if (prevIsShowCollapsible === isShowCollapsible) return;
    this.setState({
      isShowCollapsible,
    });
  }

  handleDescriptionToggle() {
    this.setState(state => ({
      moreContent: !state.moreContent,
    }));
  }

  render() {
    const {
      title,
      description,
      staticText,
    } = this.props;

    const {
      moreContent,
      isShowCollapsible,
    } = this.state;

    const descriptionClasses = {
      collapsed: isShowCollapsible && !moreContent && description,
      'description-wrapper': true,
    };

    return (
      <div className="brief-description-wrapper">
        <div className="brief-description">
          <div className="brief-description-row">
            <div className="title">
              <Typography
                as="h1"
                sizeFont="px32"
                variant="secondary"
                weight="light"
                lineHeightStyle="dp43"
                spacing="none"
              >
                {title}
              </Typography>
            </div>
            <div className="content">
              <div
                className="description-ref"
                ref={this.descriptionRef}
              >
                <HtmlParser htmlString={description} />
              </div>
              <div className={classNames(descriptionClasses)}>
                <Collapsible
                  collapsedHeightValue={1.29 * 4}
                  collapsedHeightUnit="em"
                  isCollapsed={!moreContent && isShowCollapsible}
                >
                  <HtmlParser htmlString={description} />
                </Collapsible>
              </div>
              {isShowCollapsible && description && (
                <Button
                  dark
                  text
                  rightIconName={`chevron_${moreContent ? 'up' : 'down'}`}
                  onClick={this.handleDescriptionToggle}
                >
                  {moreContent
                    ? staticText.PROVIDER_PRODUCT_PAGE_BRIEF_DESCRIPTION_SHOW_LESS
                    : staticText.PROVIDER_PRODUCT_PAGE_BRIEF_DESCRIPTION_SHOW_MORE
                  }
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// body line-height is 1.29em, so 5em should equals to 4 lines
BriefDescription.defaultProps = {
  title: null,
  description: null,
  staticText: shape({}),
};

BriefDescription.propTypes = {
  title: string,
  description: string,
  staticText: {},
};

export default BriefDescription;
